module.exports = __webpack_public_path__ + "static/media/om_beard_tailored_long__square.f0a75b4a.png";